<node-picture
    [bannerColor]="config.bannerColor"
    [bannerTitle]="config.translations.widgetTitle"
    [bannerIcon]="config.icon"
    [textColor]="config.textColor"
/>
